var React = require('react');

function TriangleDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.5 21.0002L0.808635 0.750239L24.1913 0.750241L12.5 21.0002Z","fill":"white"}));
}

TriangleDownInline.defaultProps = {"width":"25","height":"21","viewBox":"0 0 25 21","fill":"none"};

module.exports = TriangleDownInline;

TriangleDownInline.default = TriangleDownInline;
